import { render, staticRenderFns } from "./Less.vue?vue&type=template&id=2fd4f38b&"
import script from "./Less.vue?vue&type=script&lang=js&"
export * from "./Less.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports